var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/_core.js
 ** module id = 24
 ** module chunks = 19
 **/